<template>
  <div id="businessInfo">
    <a-form
      ref="stepBusinessInfoRef"
      class="ant-round-form material-other-info-form"
      layout="vertical"
      :model="modelForm"
      :rules="rules"
      @finish="submit"
    >
      <a-form-item name="openingPurpose" :label="$t('pages_merchant2_055')" :rules="{ required: true }">
        <a-select
          v-model:value="modelForm.openingPurpose"
          class="input-primary"
          :placeholder="$t('pages_merchant2_055')"
          mode="multiple"
          allow-clear
        >
          <a-select-option
            v-for="item in openingPurposeOptions"
            :key="item.value"
            :value="item.value"
          >{{ item.label }}</a-select-option>
        </a-select>
        <div v-if="!modelForm.openingPurposeDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.openingPurposeMessage }}</span>
        </div>
      </a-form-item>
      <!-- 业务类型 多选 -->
      <a-form-item name="businessNatureType" :label="$t('pages_merchant2_040')" :rules="{ required: true }">
        <a-select
          v-model:value="modelForm.businessNatureType"
          class="input-primary"
          :placeholder="$t('pages_merchant2_040')"
          mode="multiple"
          allow-clear
        >
          <a-select-option
            v-for="item in businessNatureTypeOptions"
            :key="item.value"
            :value="item.value"
          >{{ item.label }}</a-select-option>
        </a-select>
        <div v-if="!modelForm.businessNatureTypeDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.businessNatureTypeMessage }}</span>
        </div>
      </a-form-item>
      <!-- 财富来源 -->
      <a-form-item name="wealthSource" :label="$t('pages_merchant2_065')" :rules="{ required: true }">
        <a-select
          v-model:value="modelForm.wealthSource"
          class="input-primary"
          :placeholder="$t('pages_merchant2_065')"
          mode="multiple"
          allow-clear
        >
          <a-select-option
            v-for="item in wealthSourceOptions"
            :key="item.value"
            :value="item.value"
          >{{ item.label }}</a-select-option>
        </a-select>
        <div v-if="!modelForm.wealthSourceDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.wealthSourceMessage }}</span>
        </div>
      </a-form-item>
      <!-- 款项来源 多选 -->
      <a-form-item name="sourceFunds" :label="$t('pages_merchant2_062')" :rules="{ required: true }">
        <a-select
          v-model:value="modelForm.sourceFunds"
          class="input-primary"
          :placeholder="$t('pages_merchant2_062')"
          mode="multiple"
          allow-clear
        >
          <a-select-option
            v-for="item in sourceFundsOptions"
            :key="item.value"
            :value="item.value"
          >{{ item.label }}</a-select-option>
        </a-select>
        <div v-if="!modelForm.sourceFundsDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.sourceFundsMessage }}</span>
        </div>
      </a-form-item>
      <!-- 公司官网地址 -->
      <a-form-item name="companyWebsite" :label="$t('pages_merchant2_061')" :rules="{ required: false }">
        <div class="explain">{{ $t('pages_merchant2_059_0') }}</div>
        <a-input
          v-model:value="modelForm.companyWebsite"
          class="input-primary"
          :placeholder="$t('pages_merchant2_038')"
        />
        <div v-if="!modelForm.companyWebsiteDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.companyWebsiteMessage }}</span>
        </div>
      </a-form-item>
      <!-- 业务性质 多选 -->
      <a-form-item name="natures" :label="$t('pages_merchant2_039')" :rules="{ required: true }">
        <a-select
          v-model:value="modelForm.natures"
          class="input-primary"
          :placeholder="$t('pages_merchant2_039')"
          mode="multiple"
          allow-clear
        >
          <a-select-option
            v-for="item in businessNatureOptions"
            :key="item.value"
            :value="item.value"
          >{{ item.label }}</a-select-option>
        </a-select>
        <div v-if="!modelForm.naturesDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.naturesMessage }}</span>
        </div>
      </a-form-item>
      <!-- webSiteOrApp input  -->
      <a-form-item name="webSiteOrApp" :label="$t('pages_merchant2_041')" :rules="{ required: false }">
        <a-input
          v-model:value="modelForm.webSiteOrApp"
          class="input-primary"
          :placeholder="$t('pages_merchant2_041')"
        />
        <div v-if="!modelForm.webSiteOrAppDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.webSiteOrAppMessage }}</span>
        </div>
      </a-form-item>
      <!-- 业务范围描述 input  -->
      <a-form-item name="bizScopeDesc" :label="$t('pages_merchant2_042')" :rules="{ required: false }">
        <a-textarea
          v-model:value="modelForm.bizScopeDesc"
          class="input-primary"
          :placeholder="$t('pages_merchant2_042')"
          allow-clear
        />
        <div v-if="!modelForm.bizScopeDescDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.bizScopeDescMessage }}</span>
        </div>
      </a-form-item>
      <!-- 业务所在国家地区 多选 -->
      <a-form-item name="bizCountry" :label="$t('pages_merchant2_060')" :rules="{ required: true }">
        <a-select
          v-model:value="modelForm.bizCountry"
          class="input-primary"
          :placeholder="$t('pages_merchant2_060')"
          mode="multiple"
          allow-clear
          :max-tag-count="5"
          @change="handleBizCountryChange"
        >
          <a-select-option
            v-for="country in countries"
            :key="country.areaCode"
            :value="country.areaCode"
            :label="language === 'zh' ? country.areaChineseName : country.areaEnglishName"
          >{{ language === 'zh' ? country.areaChineseName : country.areaEnglishName }}</a-select-option>
        </a-select>
        <div v-if="!modelForm.bizCountryDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.bizCountryMessage }}</span>
        </div>
      </a-form-item>
      <!-- monthlyTxnCount -->
      <a-form-item name="monthlyTxnCount" :label="$t('pages_merchant2_048')" :rules="{ required: true }">
        <a-input
          v-model:value="modelForm.monthlyTxnCount"
          class="input-primary"
          :placeholder="$t('pages_merchant2_048')"
        />
        <div v-if="!modelForm.monthlyTxnCountDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.monthlyTxnCountMessage }}</span>
        </div>
      </a-form-item>
      <!-- monthlyTxnEst selection -->
      <a-form-item name="monthlyTxnEst" :label="$t('pages_merchant2_049')" :rules="{ required: true }">
        <a-select
          v-model:value="modelForm.monthlyTxnEst"
          class="input-primary"
          :placeholder="$t('pages_merchant2_049')"
        >
          <a-select-option
            v-for="item in monthlyTxnEstOptions"
            :key="item.value"
            :value="item.value"
          >{{ item.label }}</a-select-option>
        </a-select>
        <div v-if="!modelForm.monthlyTxnEstDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.monthlyTxnEstMessage }}</span>
        </div>
      </a-form-item>
      <!-- otherAccountPath input -->
      <a-form-item name="otherAccountPath" :label="$t('pages_merchant2_046')">
        <div class="explain" style="margin-bottom: 24px">
          <span>{{ $t('pages_merchant2_047') }}</span>
        </div>
        <upload-auto
          ref="uploadOtherAccountPathRef"
          v-model:file-content="modelForm.otherAccountPath"
          accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
          type="INVITE"
          list-type="picture"
          back-type="array"
          :disabled="modelForm.otherAccountPathDisabled"
          :explain="$t('pages_merchant_032')"
          :max-count="5"
        />
        <div v-if="!modelForm.otherAccountPathDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.otherAccountPathMessage }}</span>
        </div>
      </a-form-item>
      <!-- businessNatureType 包括电商 提供额外证明文件上传 -->
      <a-form-item v-if="modelForm.businessNatureType.includes('2')" name="shopProofPath" :rules="{ required: false }" :label="$t('pages_merchant2_044')">
        <!-- explain -->
        <div class="explain" style="margin-bottom: 24px">
          <span>{{ $t('pages_merchant2_045') }}</span>
        </div>
        <upload-auto
          ref="uploadShopProofPathRef"
          v-model:file-content="modelForm.shopProofPath"
          accept=".jpg,.jpeg,.png,.pdf,.bmp,.zip"
          type="INVITE"
          list-type="picture"
          back-type="array"
          :disabled="modelForm.shopProofPathDisabled"
          :explain="$t('pages_merchant_032')"
          :max-count="5"
        />
        <div v-if="!modelForm.shopProofPathDisabled && refused" class="error-area">
          <exclamation-circle-outlined class="ic-error" />
          <span>{{ modelForm.shopProofPathMessage }}</span>
        </div>
      </a-form-item>

      <a-form-item style="text-align: right; margin-top: 48px">
        <a-button
          type="primary"
          shape="round"
          ghost
          style="min-width: 138px; margin-right: 24px"
          @click="$emit('next', '3-2')"
        >{{ $t('pages_merchant_040') }}</a-button>
        <a-button
          html-type="submit"
          type="primary"
          shape="round"
          style="min-width: 138px"
        >{{ $t('pages_merchant_020') }}</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import { ref, reactive, toRefs, computed, nextTick } from 'vue'
import i18n from '@/locale'
import UploadAuto from '@/components/upload-auto'
import { message } from 'ant-design-vue'
export default {
  name: 'OtherInfo',
  components: {
    'upload-auto': UploadAuto
  },
  props: {
    model: {
      type: Object,
      default: () => { return {} }
    },
    refused: {
      type: Boolean,
      default: () => { return false }
    },
    risked: {
      type: Boolean,
      default: () => { return false }
    },
    countries: {
      type: Array,
      default: () => { return [] }
    }
  },
  setup (props, ctx) {
    const step14Ref = ref(null)
    const uploadOtherAccountPathRef = ref(null)
    const uploadShopProofPathRef = ref(null)

    const state = reactive({
      language: localStorage.getItem('locale-language') || 'zh'
    })

    const openingPurposeOptions = [
      {
        label: i18n.global.t('pages_merchant2_055_0'),
        value: '1'
      },
      {
        label: i18n.global.t('pages_merchant2_055_1'),
        value: '2'
      },
      {
        label: i18n.global.t('pages_merchant2_055_2'),
        value: '3'
      },
      {
        label: i18n.global.t('pages_merchant2_055_3'),
        value: '4'
      },
      {
        label: i18n.global.t('pages_merchant2_055_4'),
        value: '5'
      },
      {
        label: i18n.global.t('pages_merchant2_055_5'),
        value: '6'
      },
      {
        label: i18n.global.t('pages_merchant2_055_6'),
        value: '7'
      },
      {
        label: i18n.global.t('pages_merchant2_055_7'),
        value: '8'
      },
      {
        label: i18n.global.t('pages_merchant2_055_8'),
        value: '9'
      },
      {
        label: i18n.global.t('pages_merchant2_055_9'),
        value: '10'
      },
      {
        label: i18n.global.t('pages_merchant2_055_10'),
        value: '11'
      },
      {
        label: i18n.global.t('pages_merchant2_055_11'),
        value: '12'
      },
      {
        label: i18n.global.t('pages_merchant2_055_12'),
        value: '13'
      },
      {
        label: i18n.global.t('pages_merchant2_055_13'),
        value: '14'
      },
      {
        label: i18n.global.t('pages_merchant2_055_14'),
        value: '15'
      },
      {
        label: i18n.global.t('pages_merchant2_055_15'),
        value: '16'
      },
      {
        label: i18n.global.t('pages_merchant2_055_16'),
        value: '17'
      },
      {
        label: i18n.global.t('pages_merchant2_055_17'),
        value: '18'
      },
      {
        label: i18n.global.t('pages_merchant2_055_18'),
        value: '19'
      },
      {
        label: i18n.global.t('pages_merchant2_055_19'),
        value: '20'
      },
      {
        label: i18n.global.t('pages_merchant2_055_20'),
        value: '21'
      },
      {
        label: i18n.global.t('pages_merchant2_055_21'),
        value: '22'
      },
      {
        label: i18n.global.t('pages_merchant2_055_22'),
        value: '23'
      },
      {
        label: i18n.global.t('pages_merchant2_055_23'),
        value: '24'
      },
      {
        label: i18n.global.t('pages_merchant2_055_24'),
        value: '25'
      },
      {
        label: i18n.global.t('pages_merchant2_055_25'),
        value: '26'
      },
      {
        label: i18n.global.t('pages_merchant2_055_26'),
        value: '27'
      },
      {
        label: i18n.global.t('pages_merchant2_055_27'),
        value: '28'
      },
      {
        label: i18n.global.t('pages_merchant2_055_28'),
        value: '29'
      },
      {
        label: i18n.global.t('pages_merchant2_055_29'),
        value: '30'
      },
      {
        label: i18n.global.t('pages_merchant2_055_30'),
        value: '31'
      },
      {
        label: i18n.global.t('pages_merchant2_055_31'),
        value: '32'
      },
      {
        label: i18n.global.t('pages_merchant2_055_32'),
        value: '33'
      },
      {
        label: i18n.global.t('pages_merchant2_055_33'),
        value: '34'
      },
      {
        label: i18n.global.t('pages_merchant2_055_34'),
        value: '35'
      },
      {
        label: i18n.global.t('pages_merchant2_055_35'),
        value: '36'
      },
      {
        label: i18n.global.t('pages_merchant2_055_36'),
        value: '37'
      },
      {
        label: i18n.global.t('pages_merchant2_055_37'),
        value: '38'
      },
      {
        label: i18n.global.t('pages_merchant2_055_38'),
        value: '39'
      },
      {
        label: i18n.global.t('pages_merchant2_055_39'),
        value: '40'
      },
      {
        label: i18n.global.t('pages_merchant2_055_40'),
        value: '41'
      },
      {
        label: i18n.global.t('pages_merchant2_055_41'),
        value: '42'
      },
      {
        label: i18n.global.t('pages_merchant2_055_42'),
        value: '43'
      },
      {
        label: i18n.global.t('pages_merchant2_055_43'),
        value: '44'
      },
      {
        label: i18n.global.t('pages_merchant2_055_44'),
        value: '45'
      }
    ]

    const businessNatureOptions = [
      {
        label: i18n.global.t('pages_merchant2_039_0'),
        value: '1'
      },
      {
        label: i18n.global.t('pages_merchant2_039_1'),
        value: '2'
      },
      {
        label: i18n.global.t('pages_merchant2_039_2'),
        value: '3'
      },
      {
        label: i18n.global.t('pages_merchant2_039_3'),
        value: '4'
      },
      {
        label: i18n.global.t('pages_merchant2_039_4'),
        value: '5'
      },
      {
        label: i18n.global.t('pages_merchant2_039_5'),
        value: '6'
      },
      {
        label: i18n.global.t('pages_merchant2_039_6'),
        value: '7'
      },
      {
        label: i18n.global.t('pages_merchant2_039_7'),
        value: '8'
      },
      {
        label: i18n.global.t('pages_merchant2_039_8'),
        value: '9'
      },
      {
        label: i18n.global.t('pages_merchant2_039_9'),
        value: '10'
      },
      {
        label: i18n.global.t('pages_merchant2_039_10'),
        value: '11'
      },
      {
        label: i18n.global.t('pages_merchant2_039_11'),
        value: '12'
      },
      {
        label: i18n.global.t('pages_merchant2_039_12'),
        value: '13'
      },
      {
        label: i18n.global.t('pages_merchant2_039_13'),
        value: '14'
      },
      {
        label: i18n.global.t('pages_merchant2_039_14'),
        value: '15'
      },
      {
        label: i18n.global.t('pages_merchant2_039_15'),
        value: '16'
      },
      {
        label: i18n.global.t('pages_merchant2_039_16'),
        value: '17'
      },
      {
        label: i18n.global.t('pages_merchant2_039_17'),
        value: '18'
      },
      {
        label: i18n.global.t('pages_merchant2_039_18'),
        value: '19'
      },
      {
        label: i18n.global.t('pages_merchant2_039_19'),
        value: '20'
      },
      {
        label: i18n.global.t('pages_merchant2_039_20'),
        value: '21'
      },
      {
        label: i18n.global.t('pages_merchant2_039_21'),
        value: '22'
      },
      {
        label: i18n.global.t('pages_merchant2_039_22'),
        value: '23'
      },
      {
        label: i18n.global.t('pages_merchant2_039_23'),
        value: '24'
      },
      {
        label: i18n.global.t('pages_merchant2_039_24'),
        value: '25'
      },
      {
        label: i18n.global.t('pages_merchant2_039_25'),
        value: '26'
      },
      {
        label: i18n.global.t('pages_merchant2_039_26'),
        value: '27'
      },
      {
        label: i18n.global.t('pages_merchant2_039_27'),
        value: '28'
      },
      {
        label: i18n.global.t('pages_merchant2_039_28'),
        value: '29'
      },
      {
        label: i18n.global.t('pages_merchant2_039_29'),
        value: '30'
      },
      {
        label: i18n.global.t('pages_merchant2_039_30'),
        value: '31'
      },
      {
        label: i18n.global.t('pages_merchant2_039_31'),
        value: '32'
      },
      {
        label: i18n.global.t('pages_merchant2_039_32'),
        value: '33'
      },
      {
        label: i18n.global.t('pages_merchant2_039_33'),
        value: '34'
      },
      {
        label: i18n.global.t('pages_merchant2_039_34'),
        value: '35'
      },
      {
        label: i18n.global.t('pages_merchant2_039_35'),
        value: '36'
      },
      {
        label: i18n.global.t('pages_merchant2_039_36'),
        value: '37'
      },
      {
        label: i18n.global.t('pages_merchant2_039_37'),
        value: '38'
      },
      {
        label: i18n.global.t('pages_merchant2_039_38'),
        value: '39'
      },
      {
        label: i18n.global.t('pages_merchant2_039_39'),
        value: '40'
      },
      {
        label: i18n.global.t('pages_merchant2_039_40'),
        value: '41'
      },
      {
        label: i18n.global.t('pages_merchant2_039_41'),
        value: '42'
      },
      {
        label: i18n.global.t('pages_merchant2_039_42'),
        value: '43'
      },
      {
        label: i18n.global.t('pages_merchant2_039_43'),
        value: '44'
      },
      {
        label: i18n.global.t('pages_merchant2_039_44'),
        value: '45'
      },
      {
        label: i18n.global.t('pages_merchant2_039_45'),
        value: '46'
      },
      {
        label: i18n.global.t('pages_merchant2_039_46'),
        value: '47'
      },
      {
        label: i18n.global.t('pages_merchant2_039_47'),
        value: '48'
      },
      {
        label: i18n.global.t('pages_merchant2_039_48'),
        value: '49'
      },
      {
        label: i18n.global.t('pages_merchant2_039_49'),
        value: '50'
      },
      {
        label: i18n.global.t('pages_merchant2_039_50'),
        value: '51'
      },
      {
        label: i18n.global.t('pages_merchant2_039_51'),
        value: '52'
      },
      {
        label: i18n.global.t('pages_merchant2_039_52'),
        value: '53'
      },
      {
        label: i18n.global.t('pages_merchant2_039_53'),
        value: '54'
      },
      {
        label: i18n.global.t('pages_merchant2_039_54'),
        value: '55'
      },
      {
        label: i18n.global.t('pages_merchant2_039_55'),
        value: '56'
      },
      {
        label: i18n.global.t('pages_merchant2_039_56'),
        value: '57'
      },
      {
        label: i18n.global.t('pages_merchant2_039_57'),
        value: '58'
      },
      {
        label: i18n.global.t('pages_merchant2_039_58'),
        value: '59'
      },
      {
        label: i18n.global.t('pages_merchant2_039_59'),
        value: '60'
      },
      {
        label: i18n.global.t('pages_merchant2_039_60'),
        value: '61'
      },
      {
        label: i18n.global.t('pages_merchant2_039_61'),
        value: '62'
      },
      {
        label: i18n.global.t('pages_merchant2_039_62'),
        value: '1001'
      },
      {
        label: i18n.global.t('pages_merchant2_039_63'),
        value: '1002'
      },
      {
        label: i18n.global.t('pages_merchant2_039_64'),
        value: '1003'
      },
      {
        label: i18n.global.t('pages_merchant2_039_65'),
        value: '1004'
      },
      {
        label: i18n.global.t('pages_merchant2_039_66'),
        value: '1005'
      },
      {
        label: i18n.global.t('pages_merchant2_039_67'),
        value: '1006'
      },
      {
        label: i18n.global.t('pages_merchant2_039_68'),
        value: '1007'
      },
      {
        label: i18n.global.t('pages_merchant2_039_69'),
        value: '1008'
      },
      {
        label: i18n.global.t('pages_merchant2_039_70'),
        value: '1009'
      },
      {
        label: i18n.global.t('pages_merchant2_039_71'),
        value: '1010'
      },
      {
        label: i18n.global.t('pages_merchant2_039_72'),
        value: '1011'
      },
      {
        label: i18n.global.t('pages_merchant2_039_73'),
        value: '1012'
      },
      {
        label: i18n.global.t('pages_merchant2_039_74'),
        value: '1013'
      },
      {
        label: i18n.global.t('pages_merchant2_039_75'),
        value: '1014'
      },
      {
        label: i18n.global.t('pages_merchant2_039_76'),
        value: '1015'
      },
      {
        label: i18n.global.t('pages_merchant2_039_77'),
        value: '1016'
      },
      {
        label: i18n.global.t('pages_merchant2_039_78'),
        value: '1017'
      },
      {
        label: i18n.global.t('pages_merchant2_039_79'),
        value: '1018'
      },
      {
        label: i18n.global.t('pages_merchant2_039_80'),
        value: '1019'
      },
      {
        label: i18n.global.t('pages_merchant2_039_81'),
        value: '1020'
      },
      {
        label: i18n.global.t('pages_merchant2_039_82'),
        value: '1021'
      },
      {
        label: i18n.global.t('pages_merchant2_039_83'),
        value: '1022'
      },
      {
        label: i18n.global.t('pages_merchant2_039_84'),
        value: '1023'
      },
      {
        label: i18n.global.t('pages_merchant2_039_85'),
        value: '1024'
      },
      {
        label: i18n.global.t('pages_merchant2_039_86'),
        value: '1025'
      },
      {
        label: i18n.global.t('pages_merchant2_039_87'),
        value: '1026'
      },
      {
        label: i18n.global.t('pages_merchant2_039_88'),
        value: '1027'
      },
      {
        label: i18n.global.t('pages_merchant2_039_89'),
        value: '1028'
      },
      {
        label: i18n.global.t('pages_merchant2_039_90'),
        value: '1029'
      },
      {
        label: i18n.global.t('pages_merchant2_039_91'),
        value: '1030'
      },
      {
        label: i18n.global.t('pages_merchant2_039_92'),
        value: '1031'
      },
      {
        label: i18n.global.t('pages_merchant2_039_93'),
        value: '1032'
      },
      {
        label: i18n.global.t('pages_merchant2_039_94'),
        value: '1033'
      },
      {
        label: i18n.global.t('pages_merchant2_039_95'),
        value: '1034'
      },
      {
        label: i18n.global.t('pages_merchant2_039_96'),
        value: '1035'
      },
      {
        label: i18n.global.t('pages_merchant2_039_97'),
        value: '1036'
      },
      {
        label: i18n.global.t('pages_merchant2_039_98'),
        value: '1037'
      },
      {
        label: i18n.global.t('pages_merchant2_039_99'),
        value: '1038'
      },
      {
        label: i18n.global.t('pages_merchant2_039_100'),
        value: '1039'
      },
      {
        label: i18n.global.t('pages_merchant2_039_101'),
        value: '1040'
      },
      {
        label: i18n.global.t('pages_merchant2_039_102'),
        value: '1041'
      },
      {
        label: i18n.global.t('pages_merchant2_039_103'),
        value: '1042'
      },
      {
        label: i18n.global.t('pages_merchant2_039_104'),
        value: '1043'
      },
      {
        label: i18n.global.t('pages_merchant2_039_105'),
        value: '1044'
      },
      {
        label: i18n.global.t('pages_merchant2_039_106'),
        value: '1045'
      },
      {
        label: i18n.global.t('pages_merchant2_039_107'),
        value: '1046'
      },
      {
        label: i18n.global.t('pages_merchant2_039_108'),
        value: '1047'
      },
      {
        label: i18n.global.t('pages_merchant2_039_109'),
        value: '1048'
      },
      {
        label: i18n.global.t('pages_merchant2_039_110'),
        value: '1049'
      },
      {
        label: i18n.global.t('pages_merchant2_039_111'),
        value: '1050'
      },
      {
        label: i18n.global.t('pages_merchant2_039_112'),
        value: '1051'
      },
      {
        label: i18n.global.t('pages_merchant2_039_113'),
        value: '1052'
      },
      {
        label: i18n.global.t('pages_merchant2_039_114'),
        value: '1053'
      },
      {
        label: i18n.global.t('pages_merchant2_039_115'),
        value: '1054'
      },
      {
        label: i18n.global.t('pages_merchant2_039_116'),
        value: '1055'
      },
      {
        label: i18n.global.t('pages_merchant2_039_117'),
        value: '1056'
      },
      {
        label: i18n.global.t('pages_merchant2_039_118'),
        value: '1057'
      },
      {
        label: i18n.global.t('pages_merchant2_039_119'),
        value: '1058'
      },
      {
        label: i18n.global.t('pages_merchant2_039_120'),
        value: '1059'
      },
      {
        label: i18n.global.t('pages_merchant2_039_121'),
        value: '1060'
      },
      {
        label: i18n.global.t('pages_merchant2_039_122'),
        value: '1061'
      },
      {
        label: i18n.global.t('pages_merchant2_039_123'),
        value: '1062'
      },
      {
        label: i18n.global.t('pages_merchant2_039_124'),
        value: '1063'
      },
      {
        label: i18n.global.t('pages_merchant2_039_125'),
        value: '1064'
      },
      {
        label: i18n.global.t('pages_merchant2_039_126'),
        value: '1065'
      },
      {
        label: i18n.global.t('pages_merchant2_039_127'),
        value: '1066'
      },
      {
        label: i18n.global.t('pages_merchant2_039_128'),
        value: '1067'
      }
    ]

    const businessNatureTypeOptions = [
      { value: '0', label: i18n.global.t('pages_merchant2_040-1') },
      { value: '1', label: i18n.global.t('pages_merchant2_040-2') },
      { value: '2', label: i18n.global.t('pages_merchant2_040-3') }
    ]

    const monthlyTxnEstOptions = [
      { value: '0', label: i18n.global.t('pages_merchant2_049-0') },
      { value: '1', label: i18n.global.t('pages_merchant2_049-1') },
      { value: '2', label: i18n.global.t('pages_merchant2_049-2') },
      { value: '3', label: i18n.global.t('pages_merchant2_049-3') },
      { value: '4', label: i18n.global.t('pages_merchant2_049-4') },
      { value: '5', label: i18n.global.t('pages_merchant2_049-5') }
    ]

    const sourceFundsOptions = [
      { value: '1', label: i18n.global.t('pages_merchant2_062_1') },
      { value: '2', label: i18n.global.t('pages_merchant2_062_2') },
      { value: '3', label: i18n.global.t('pages_merchant2_062_3') },
      { value: '4', label: i18n.global.t('pages_merchant2_062_4') },
      { value: '5', label: i18n.global.t('pages_merchant2_062_5') },
      { value: '6', label: i18n.global.t('pages_merchant2_062_6') }
    ]

    const wealthSourceOptions = [
      { value: '1', label: i18n.global.t('pages_merchant2_065_1') },
      { value: '2', label: i18n.global.t('pages_merchant2_065_2') },
      { value: '3', label: i18n.global.t('pages_merchant2_065_3') },
      { value: '4', label: i18n.global.t('pages_merchant2_065_4') },
      { value: '5', label: i18n.global.t('pages_merchant2_065_5') },
      { value: '6', label: i18n.global.t('pages_merchant2_065_6') },
      { value: '7', label: i18n.global.t('pages_merchant2_065_7') },
      { value: '8', label: i18n.global.t('pages_merchant2_065_8') },
      { value: '9', label: i18n.global.t('pages_merchant2_065_9') },
      { value: '10', label: i18n.global.t('pages_merchant2_065_10') },
      { value: '11', label: i18n.global.t('pages_merchant2_065_11') },
      { value: '12', label: i18n.global.t('pages_merchant2_065_12') },
      { value: '13', label: i18n.global.t('pages_merchant2_065_13') }
    ]

    state.modelForm = computed(() => {
      return props.model
    })

    const validateAtLeastOne = (rule, value) => {
      // 如果当前字段有值，则直接通过验证
      if (value) {
        return Promise.resolve()
      }

      // 如果业务类型包括电商， webSiteOrApp 必填
      if (state.modelForm.businessNatureType.includes('2') && rule.field === 'webSiteOrApp') {
        return Promise.reject(i18n.global.t('pages_merchant2_057'))
      }

      // 否则检查另一个字段是否有值
      const otherField = rule.field === 'webSiteOrApp' ? 'businessScope' : 'webSiteOrApp'
      const otherValue = state.modelForm[otherField]

      // 如果另一个字段也没有值，则验证失败
      if (!otherValue) {
        return Promise.reject(i18n.global.t('pages_merchant2_043'))
      }

      // 至少有一个字段有值，验证通过
      return Promise.resolve()
    }

    const submit = () => {
      ctx.emit('next', props.risked ? '3-4' : '3-5')
    }

    nextTick(() => {
      const { otherAccountPath, shopProofPath } = state.modelForm
      if (otherAccountPath.length !== 0 && uploadOtherAccountPathRef.value) uploadOtherAccountPathRef.value.fileListRefresh(otherAccountPath)
      if (shopProofPath.length !== 0 && uploadShopProofPathRef.value) uploadShopProofPathRef.value.fileListRefresh(shopProofPath)
    })

    const handleBizCountryChange = (selectedValues) => {
      if (selectedValues.length > 5) {
        message.warning(i18n.global.t('pages_merchant2_036_1'))
        state.modelForm.bizCountry = selectedValues.slice(0, 5)
      }
    }

    return {
      step14Ref,
      businessNatureTypeOptions,
      businessNatureOptions,
      monthlyTxnEstOptions,
      openingPurposeOptions,
      wealthSourceOptions,
      sourceFundsOptions,
      validateAtLeastOne,
      submit,
      uploadOtherAccountPathRef,
      uploadShopProofPathRef,
      handleBizCountryChange,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="less" scoped>
#otherInfo {
  .material-other-info-form {
    .explain {
      color: #495060;
    }
    .input-primary:deep(.ant-input) {
      border-radius: 5px;
    }
  }
}

</style>

